import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../../apiConfigs/axiosInstance";
import {
  ERROR__TOASTER,
  REQUIRED__TOASTER,
} from "../../../../helpers/utils/TosterError";
import { renderDynamicUrlFromState } from "../../../../helpers/utils/urlHelper";

const BASE = "success-stories";

export const getSuccessStories = createAsyncThunk(
  "getSuccessStories",
  async (_: void, { rejectWithValue, getState }) => {
    try {
      const state = getState();
      const dynamic_url = renderDynamicUrlFromState(state);
      const res = await axiosInstance.get(`${dynamic_url}/${BASE}`);
      return { data: res.data };
    } catch (error: any) {
      if (!error.response) throw error;
      return rejectWithValue(error.response.data);
    }
  }
);

export const addSuccessStory = createAsyncThunk(
  "addSuccessStory",
  async (data: any, { rejectWithValue, getState }) => {
    try {
      const state = getState();
      const dynamic_url = renderDynamicUrlFromState(state);
      const res = await axiosInstance.post(`${dynamic_url}/${BASE}`, data);
      REQUIRED__TOASTER(res.data);
      return res.data;
    } catch (error: any) {
      ERROR__TOASTER(error);
      return rejectWithValue(error.response?.data);
    }
  }
);

export const updateSuccessStory = createAsyncThunk(
  "updateSuccessStory",
  async (
    { id, data }: { id: number | string; data: any },
    { rejectWithValue, getState }
  ) => {
    try {
      const state = getState();
      const dynamic_url = renderDynamicUrlFromState(state);
      const res = await axiosInstance.post(
        `${dynamic_url}/${BASE}/${id}`,
        data
      );
      REQUIRED__TOASTER(res.data);
      return res.data;
    } catch (error: any) {
      ERROR__TOASTER(error);
      return rejectWithValue(error.response?.data);
    }
  }
);

export const deleteSuccessStory = createAsyncThunk(
  "deleteSuccessStory",
  async (id: number | string, { rejectWithValue, getState }) => {
    try {
      const state = getState();
      const dynamic_url = renderDynamicUrlFromState(state);
      const res = await axiosInstance.delete(`${dynamic_url}/${BASE}/${id}`);
      REQUIRED__TOASTER(res.data);
      return { ...res.data, id };
    } catch (error: any) {
      ERROR__TOASTER(error);
      return rejectWithValue(error.response?.data);
    }
  }
);

export const toggleSuccessStoryStatus = createAsyncThunk(
  "toggleSuccessStoryStatus",
  async (id: number | string, { rejectWithValue, getState }) => {
    try {
      const state = getState();
      const dynamic_url = renderDynamicUrlFromState(state);
      const res = await axiosInstance.post(
        `${dynamic_url}/${BASE}/${id}/toggle-status`
      );
      REQUIRED__TOASTER(res.data);
      return res.data;
    } catch (error: any) {
      ERROR__TOASTER(error);
      return rejectWithValue(error.response?.data);
    }
  }
);

export const reorderSuccessStories = createAsyncThunk(
  "reorderSuccessStories",
  async (
    { orders }: { orders: { id: number; order: number }[] },
    { rejectWithValue, getState }
  ) => {
    try {
      const state = getState();
      const dynamic_url = renderDynamicUrlFromState(state);
      const res = await axiosInstance.post(
        `${dynamic_url}/${BASE}/reorder`,
        { orders }
      );
      return res.data;
    } catch (error: any) {
      ERROR__TOASTER(error);
      return rejectWithValue(error.response?.data);
    }
  }
);
